import React from "react";
import { Button, Box } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function UpdateButton() {
  const handleUpdate = () => {
    if (window.checkForUpdates) {
      window.checkForUpdates();
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
      }}
    >
      <Button
        variant="contained"
        color="primary"
        startIcon={<RefreshIcon />}
        onClick={handleUpdate}
        sx={{
          backgroundColor: "rgba(33, 150, 243, 0.9)",
          backdropFilter: "blur(8px)",
          "&:hover": {
            backgroundColor: "rgba(33, 150, 243, 1)",
            transform: "scale(1.05)",
          },
          transition: "all 0.3s ease",
          borderRadius: "20px",
          px: 3,
          py: 1,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        Actualizar Aplicación
      </Button>
    </Box>
  );
} 